import styled, { css } from "styled-components";
import { media } from "../../../../../layouts/utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  filter: ${({ blur }) => (blur ? "blur(2px)" : "")};
  user-select: ${({ blur }) => (blur ? "none" : "auto")};
  .botoesCupons {
    display: flex;
    gap: 1.5rem;
    ${media.phone`
			flex-direction: column !important;
			gap: 1rem;
 		`}
  }
`;
export const Terms = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.875rem;
  color: #24206b;
  font-size: 1rem;

  p {
    ${media.phone`
      margin-left: 5px;
    `}
  }

  b {
    font-weight: normal;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      filter: brightness(1.2);
    }
  }

  ${media.phone`
	  font-size: 1.05rem;
    padding: 16px 16px;
 `}
`;

export const Link = styled.a`
  text-decoration: none;
  ${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`;

export const ModalHeader = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  width: 100%;
  height: 40px;
`;

export const CloseButton = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    filter: brightness(2);
  }
`;

const buttonEnabled = css`
  cursor: pointer;
  color: ${({ color }) => color};
  &:hover {
    height: 4rem;
    //to balance new height colateral
    margin-bottom: -0.5rem;
    margin-right: -0.5rem;
    min-width: 15rem; // + .5em from default
    padding: 1rem 2.75rem;
    //to balance side padding collateral
    transform: translate(-0.25rem, -0.25rem);
  }
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ backgroundColor }) => backgroundColor} !important;
  color: ${({ color }) => color};
  opacity: 0.6;
`;

export const Button = styled.div`
  user-select: none;
  height: 3.5rem;
  min-width: 14rem;
  padding: 0.9rem 2.5rem;
  font-family: "Galano Grotesque Alt";
  font-size: 1rem;
  transition: all 0.1s ease-in 0s;
  border-radius: 9999px;
  text-align: center;
  color: ${({ color }) => color};
  background-color: #230c87;
  ${({ disabled }) => (disabled ? buttonDisabled : buttonEnabled)}
`;

export const Line = styled.p`
  margin-bottom: 0.75rem;
  font-weight: 100;

  .bold {
    font-weight: bold;
  }
  .italic {
    font-style: italic;
  }
  .underline {
    text-decoration: underline;
  }
  .strike {
    text-decoration: line-through;
  }
`;
export const TextBlock = styled.span`
  &.underline {
    text-decoration: underline;
  }
  &.bold {
    font-weight: bold;
  }
  &.italic {
    font-style: italic;
  }
`;
